module.exports = __webpack_public_path__ + "static/media/pallet-alt.3aa9fb51.svg";